import { createSlice } from '@reduxjs/toolkit';
import { ProjectsState } from '@/redux/projects/projects.types';

import {
  getProjectsReducer,
  removeProjectReducer,
  shareProjectReducer,
  archiveProjectReducer,
  reviveProjectReducer,
  getProjectByIdReducer,
} from '@/redux/projects/projects.reducers';

const initialState: ProjectsState = {
  data: [],
  loading: 'idle',
  error: { name: '', message: '' },
};

const projectsSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {},
  extraReducers: builder => {
    getProjectsReducer(builder);
    removeProjectReducer(builder);
    shareProjectReducer(builder);
    archiveProjectReducer(builder);
    reviveProjectReducer(builder);
    getProjectByIdReducer(builder);
  },
});

export default projectsSlice.reducer;
